import { Search, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export function SearchBar({ value, onChange, autoFocus = false }) {
  const { t } = useLang();
  return (
    <div className="relative" data-testid="search-bar">
      <Search className="pointer-events-none absolute start-4 top-1/2 h-5 w-5 -translate-y-1/2 text-muted-foreground" />
      <input
        type="text"
        value={value}
        autoFocus={autoFocus}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("searchPlaceholder")}
        className="h-12 w-full rounded-full border border-border bg-card ps-12 pe-11 text-[15px] shadow-soft outline-none transition-colors placeholder:text-muted-foreground focus:border-primary focus:ring-2 focus:ring-primary/20"
        data-testid="search-input"
        aria-label={t("searchPlaceholder")}
      />
      {value && (
        <button
          onClick={() => onChange("")}
          className="absolute end-3 top-1/2 grid h-7 w-7 -translate-y-1/2 place-items-center rounded-full bg-secondary text-muted-foreground active:scale-90"
          aria-label={t("close")}
          data-testid="search-clear-btn"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
